import { render, staticRenderFns } from "./TBackButton.vue?vue&type=template&id=b804e66a&"
import script from "./TBackButton.vue?vue&type=script&lang=ts&"
export * from "./TBackButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports